// extracted by mini-css-extract-plugin
var _1 = "ComponentLabel-moduleComponentLabel__tFgQX";
var _2 = "ComponentLabel-modulename__qyD3C";
export { _1 as "ComponentLabel", _2 as "name" }
